import styled from "styled-components";
import { ContainerSection } from "@/main/components/shared/styles";

export const Container = styled(ContainerSection)`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 1rem;

	@media (max-width: 426px) {
		grid-template-columns: 1fr;
	}
`;

export const SelfSuppliedCell = styled.div`
	grid-column: 1;

	@media (max-width: 426px) {
		grid-column: auto;
	}
`;
